
export type CustomFieldParams = {

    listItems?          : any[]             // i guess options


    decimalPlaces?      : number            //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE, FieldType.FORMULA

    positiveOnly?       : boolean           //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE
    integersOnly?       : boolean           //  FieldType.NUMBER, FieldType.CURRENCY, FieldType.PERCENTAGE

    symbol?             : string            //  FieldType.CURRENCY, FieldType.FORMULA
    ratingType?         : any               //  FieldType.RATING
    formula             : string            //  FieldType.FORMULA
    formatType          : any               //  FieldType.FORMULA

    scope               : CustomFieldScope[]

    displayName?        : string            // any field display name if defined

    referenceProjectId? : ID                // FieldType.INTERNAL_DB
}


export enum CustomFieldScope {
    TASK        = 1,
    PROJECT     = 2,
    USER        = 3,
    CUSTOM      = 100       // ???
}

export enum CustomFieldAccess {
    EVERYONE            = 1,                // voobche vse... gd.const.companyRole.CLIENT,
    MANAGERS_ONLY       = 4,                // oups... eto full access project gd.const.companyRole.MANAGER
}



export const CustomFieldAccessOptions : Option[] = [
    {
        value   : CustomFieldAccess.MANAGERS_ONLY,
        label   : "Organization managers"
    },
    {
        label: "Everyone",
        value: CustomFieldAccess.EVERYONE
    }
]

export enum CustomFieldV1Type {
    STRING = 1,
    BOOLEAN = 2,
    NUMBER = 3,
    CURRENCY = 4,
    PERCENTAGE = 5,
    DATE = 6,
    LIST = 7,
    LIST_MULTI = 14,
    RATING = 8,
    EMAIL = 9,
    PHONE = 10,
    URL = 11,
    USER = 12,
    USERS = 17,
    TEXT = 13,
    RAG = 15,
    FORMULA = 16,
    DATE_RANGE = 18,
    COLOR = 19,

    // Fields V3
    REACTION = 20,
    VOTING = 21,
    ATTACHMENT = 22,
    TOGGLE = 23,
    TIME_OF_DAY = 24, // Time of day
    DATE_AND_TIME = 25,
    ADDRESS = 26,
    INTERNAL_DB = 27, // internal DB
    DEPARTMENT = 28,
    SKILLS = 27
}
